import { render, staticRenderFns } from "./BirthdayAnniversaryWidget.vue?vue&type=template&id=0117baa2&scoped=true&"
import script from "./BirthdayAnniversaryWidget.vue?vue&type=script&lang=js&"
export * from "./BirthdayAnniversaryWidget.vue?vue&type=script&lang=js&"
import style0 from "./BirthdayAnniversaryWidget.vue?vue&type=style&index=0&id=0117baa2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0117baa2",
  null
  
)

export default component.exports